export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--3.b0a5ce04.png";